module.exports = __webpack_public_path__ + "819a1ad6c18bf0170376af9fb2ce3c23.MP3";